'use client';

import { AutoformatKit } from "@/components/ui/platejs/autoformat-kit";
import { BasicBlocksKit } from "@/components/ui/platejs/basic-blocks-kit";
import { BasicMarksKit } from "@/components/ui/platejs/basic-marks-kit";
import { CodeBlockKit } from "@/components/ui/platejs/code-block-kit";
import { LinkKit } from "@/components/ui/platejs/link-kit";
import { ListKit } from "@/components/ui/platejs/list-kit";
import { MarkdownKit } from "@/components/ui/platejs/markdown-kit";
import { Value } from "platejs";
import { TPlateEditor, useEditorRef } from "platejs/react";

export const EditorKit = [
  // 基础块（Paragraph, Heading等）
  ...BasicBlocksKit,

  // 基础标记（Bold, Italic, Code等）
  ...BasicMarksKit,

  // Markdown解析与序列化
  ...MarkdownKit,

  // 链接（Markdown常用）
  ...LinkKit,

  // 列表（Markdown常用）
  ...ListKit,

  // 代码块（Markdown常用）
  ...CodeBlockKit,

  // 可选：自动格式化（增强Markdown输入体验）
  ...AutoformatKit,

];


export type MyEditor = TPlateEditor<Value, (typeof EditorKit)[number]>;

export const useEditor = () => useEditorRef<MyEditor>();
